import $services from "../services";

export default {
    namespaced: true,
    state: {
        session: $services.session.empty(),
        ready: false,
    },
    getters: {
        getSession: state => state.session,
        getValid: state => state.session.valid,
    },
    mutations: {
        setSession: (state, session) => {
            state.session = session;
            state.ready = true;
        },
        setReady: (state, ready) => state.ready = state.ready || ready,
    },
    actions: {
        async waitForSession(context) {
            if (context.state.ready === false) {
                const token = $services.session.restoreSession();
                const ready = context.dispatch('setToken', token);
                context.commit('setReady', ready);
            }
            if (context.state.ready instanceof Promise) {
                await context.state.ready;
            }
        },
        async setToken(context, token) {
            const session = await $services.session.getSession(token);
            $services.session.storeSession(session.token);
            context.commit('setSession', session);
            return session.valid;
        },
        removeSession: context => {
            $services.session.removeSession();
            context.commit('setSession', $services.session.empty());
        }
    }
}